import { ref, computed } from "vue";
import { e as extractHTMLElement } from "../../../composables/useHTMLElement-beee793a.mjs";
import { u as useDocument } from "../../../composables/useDocument-5c9446c6.mjs";
const useAnchorSelector = (props) => {
  const anchorRef = ref();
  const document = useDocument();
  const computedAnchorRef = computed({
    set(v) {
      anchorRef.value = extractHTMLElement(v);
    },
    get() {
      var _a, _b;
      if (props.anchorSelector) {
        return ((_a = document.value) == null ? void 0 : _a.querySelector(props.anchorSelector)) ?? anchorRef.value;
      } else if (props.innerAnchorSelector && anchorRef.value) {
        return ((_b = anchorRef.value) == null ? void 0 : _b.querySelector(props.innerAnchorSelector)) ?? anchorRef.value;
      }
      return anchorRef.value;
    }
  });
  return {
    anchorRef: computedAnchorRef
  };
};
export {
  useAnchorSelector as u
};
//# sourceMappingURL=useAnchorSelector-28e948a7.mjs.map
